// extracted by mini-css-extract-plugin
export default {"filters-box":"all-articles_filters-box__NRdjH","rounded-box":"all-articles_rounded-box__+HliQ","filters-button":"all-articles_filters-button__e66T6"};